<template>
  <div>
    <a-modal v-model="editMasterOrder" footer="" :confirmLoading="editConfirmLoading" title="编辑订单" width="85%" :maskClosable="false">
      <a-tabs :activeKey="tabs_key" @change="callback">
        <a-tab-pane key="1" tab="订单详情">
          <div style="margin: 20px;">
            <span style="font-size: 24px;font-weight: bold">基础信息</span>
          </div>
          <div class="table-page-search-wrapper">
            <!--基础信息-->
            <a-form layout="inline" :form="form">
              <a-row :gutter="24" style="margin-left: 20px">
                <a-col :span="7">
                  <a-form-item label="客户姓名">
                    <a-input v-decorator="['clientName', { rules: [{ required: true, message: '请填写客户姓名!'}] }]" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="1">
                  <a title="复制">
                    <a-icon type="copy" class="copy" @click="Copys"/></a>
                </a-col>
                <a-col :span="8">
                  <a-form-item label="联系方式">
                    <a-input v-decorator="['clientPhone', { rules: [{ required: true, message: '请填写联系方式!', pattern: /^1[3456789]\d{9}$/}] }]" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="8">
                  <a-row>
                    <a-col :span="18">
                      <a-form-item label="期望安装时间">
                        <a-date-picker @change="onChangerangepicker" style="width: 100%" format="YYYY-MM-DD" v-model="expectInstallTime" disabled/>
                      </a-form-item>
                    </a-col>
                    <a-col :span="6">
                      <a-form-item label="" :labelCol="labelCol" :wrapperCol="wrapperCol">
                        <a-select :getPopupContainer="getPopupContainer" @change="onChanginstallTimeible" v-decorator="['expectInstallTimePart']" :allowClear="true" disabled>
                          <a-select-option v-for="type in timeselect" :key="type.value">{{type.label}}</a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="12">
                  <a-row>
                    <a-col :span="9">
                      <a-form-item label="客户地址">
                        <a-select showSearch :filterOption="filterOption" @change="getProvince" v-decorator="['provinceCode', { rules: [{ required: true, message:'请选择客户地址!' }] }]" disabled>
                          <a-select-option v-for="type in selectAllProvince" :key="type.provinceCode" :title="type.provinceName">
                            {{type.provinceName}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-item>
                        <a-select showSearch :filterOption="filterOption" v-decorator="['cityCode', { rules: [{ required: true, message:'请选择客户地址!' }] }]" @change="getCityName" disabled>
                          <a-select-option v-for="type in selectCityName" :title="type.cityName" :key="type.cityCode">
                            {{type.cityName}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                    <a-col :span="7">
                      <a-form-item>
                        <a-select showSearch :filterOption="filterOption" v-decorator="['countyCode', { rules: [{ required: true, message:'请选择客户地址!' }] }]" @change="getAreaName" disabled>
                          <a-select-option v-for="type in selectAreaName" :title="type.areaName" :key="type.areaCode">
                            {{type.areaName}}
                          </a-select-option>
                        </a-select>
                      </a-form-item>
                    </a-col>
                  </a-row>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="详细地址" style="width:100%" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['detailAddress',{ rules: [{ required: true, message: '请填写详细地址!' }] },]" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="12">
                  <a-form-item label="客户要求" style="margin-left: 9px" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-textarea v-decorator="['clientRequire']" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="订单号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['orderNo']" disabled/>
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="序列号" :labelCol="labelCol" :wrapperCol="wrapperCol">
                    <a-input v-decorator="['serialNumber']" disabled/>
                  </a-form-item>
                </a-col>
              </a-row>
            </a-form>
            <!--包裹-->
            <div>
              <a-row style="margin-left: 36px;margin: 0px;">
                <a-col :span="2" style="display: flex;justify-content: flex-start;margin-left: 36px;margin-left: 20px;">
                  <a-button @click="packageAdd" icon="plus" type="primary" style="margin: 20px 0;" :disabled="transportList.length>=5">新增包裹</a-button>
                </a-col>
                <a-col :span="22"></a-col>
              </a-row>
              <a-table size="default" ref="packTable" :loading="packLoading" :columns="columnspackage" :dataSource="transportList" :pagination="false" bordered>
                <span slot="action" slot-scope="text, record">
                  <a @click="packageEdit(record)">编辑</a>
                  <a-divider type="vertical"/>
                  <a-popconfirm title="是否要删除此行？" @confirm="removepackage(record.transportId)">
                    <a>删除</a>
                  </a-popconfirm>
                </span>
              </a-table>
            </div>
            <!--新增配件-->
            <div>
              <div class="orderKeyword" style="margin: 20px "><label style="font-size: 24px;font-weight: bold">配件信息</label></div>
              <a-row style="margin-left: 36px;margin: 0px;">
                <a-col :span="2" style="display: flex;justify-content: flex-start;margin-left: 36px;margin-left: 20px;">
                  <a-button @click="accessoryAdd" icon="plus" type="primary" style="margin: 20px 0;">
                    新增配件
                  </a-button>
                </a-col>
                <a-col :span="22"></a-col>
              </a-row>
              <a-table size="default" ref="accessoryTable" :loading="accessoryTableLoading" :columns="columnsAddaccessories" :scroll="{ x: 1300 }" :dataSource="accessoryList" :pagination="false" bordered>
                <span slot="action" slot-scope="text, record">
                  <a @click="accessoryEdit(record)">编辑</a>
                  <a-divider type="vertical" v-if="record.accessoryStatus==3" />
                  <a v-if="record.accessoryStatus==3" @click="partsReturn(record)">退回</a>
                  <a-divider type="vertical" v-if="record.accessoryStatus!=2&&record.accessoryStatus!=1" />
                  <a-popconfirm title="是否要作废配件？" @confirm="partsObsolete (record.orderAccessoryId)" v-if="record.accessoryStatus!=2 && record.accessoryStatus!=1">
                    <a>作废</a>
                  </a-popconfirm>
                </span>
                <span slot="transport" slot-scope="text, record">
                  <a @click="gettransport(record.transportCode,record.transportNo)">{{record.transportNo}}</a>
                </span>
              </a-table>
            </div>
          </div>
        </a-tab-pane>
        <a-tab-pane key="2" tab="金额信息">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" :form="formmoney">
              <a-row :gutter="24">
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单号" style="margin-left: 60px">
                    <a-input v-decorator="['orderNo']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="安装类别" style="margin-left: 45px">
                    <a-input v-decorator="['installTypeName']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="订单类型" style="margin-left: 45px">
                    <a-input v-decorator="['orderTypeName']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="数量" style="margin-left: 75px">
                    <a-input v-decorator="['num']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="企业名称" style="margin-left: 45px">
                    <a-input v-decorator="['enterpriseName']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="师傅订单总金额">
                    <a-input v-decorator="['masterTotalAmount']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :md="6" :sm="24">
                  <a-form-item label="师傅结算总金额 ">
                    <a-input v-decorator="['masterSettlementAount']" disabled="disabled" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-divider/>
              <div>
                <div style="text-align: center;font-size: 24px;font-weight: bold;margin: 20px;">师傅金额</div>
                <a-table size="default" ref="amountTable" :columns="columnsenterprise" :dataSource="amountList"
                         :form="form" :pagination="false" bordered>
                  <span v-if="falg" slot="action" slot-scope="text, record, index">
                    <a v-if="record.priceId" @click="submissionPrice(record, index,'master')">改价</a>
                    <a v-if="!record.priceId" @click="submissionPrice(record, index,'master')">修改</a>
                  </span>
                </a-table>
              </div>
            </a-form>
          </div>
        </a-tab-pane>
        <a-tab-pane key="3" tab="销单资料">
          <div :class="single ? '':'disEvents'">
            <div v-for="(type,index) in salepicList">
              <a-row style="padding: 30px">
                <a-col :span="4">
                  <span style="padding:15px">{{type.infoName}}照片</span>
                  <a-upload :multiple="true" name="file" list-type="picture-card" :file-list="type.salepicfileList" class="avatar-uploader"
                            :headers="headers" :data={type:type.infoName} :action="uploadUrl" :before-upload="beforeUpload"
                            @preview="handlePreview" @change="salepichandleChange(type.infoName,type.infoPath,$event,index)"
                  >
                    <a-icon type="upload" />
                    <div class="ant-upload-text">
                      上传照片
                    </div>
                  </a-upload>
                </a-col>
                <a-col :span="20">
                  <a-row>
                    <a-col :span="5" v-for="tab in type.dataInfoList" style="height: 250px;margin-left: 30px;position: relative;">
                      <p style="text-align: center">{{tab.name}}</p>
                      <a href="#" onclick="return false;">
                        <a-icon type="eye" @click="previewimg(tab.url)" style="width: 20px;height: 20px;position: absolute;right: 92px;top:42px;font-size:23px;color: #F7F7F7" />
                        <a-icon type="check-circle" @click="disablesale(tab.uid,0)" v-if="tab.forbiddenStatus==1" style="width: 20px;height: 20px;position: absolute;right: 57px;top:42px;font-size:20px;color: #F7F7F7" />
                        <a-icon type="stop" @click="disablesale(tab.uid,1)" v-if="tab.forbiddenStatus==0" style="width: 20px;height: 20px;position: absolute;right: 57px;top:42px;font-size:20px;color: #F7F7F7" />
                        <a-icon type="delete" theme="filled" @click="deletesale('salepicList',tab.uid,tab.url)" style="width: 20px;height: 20px;position: absolute;right: 25px;top:42px;font-size:20px;color: #F7F7F7" />
                      </a>
                      <img :src="process+'?fileName='+tab.url+'&token='+token" style="margin-bottom: 20px;width:90%;height:70%;">
                      <!--<img-->
                      <!--src="https://zos.alipayobjects.com/rmsportal/jkjgkEfvpUPVyRjUImniVslZfWPnJuuZ.png" style="margin-bottom: 20px;width:90%;height:70%;" class="img-thumbnail img-circle img-responsive" >-->
                      <div>{{tab.createTime}}</div>
                      <div>{{tab.createBy }}</div>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-divider/>
            </div>
            <div v-for="(type,index) in salevideoList">
              <a-row style="padding: 30px">
                <a-col :span="4">
                  <span style="padding:15px">{{type.infoName}}视频</span>
                  <a-upload name="file" :multiple="true" list-type="picture" accept="video/*" class="avatar-uploader"
                            :headers="headers" :data={type:type.infoName} :action="uploadUrl" :showUploadList="false"
                            :before-upload="beforeUpload2" @change="salevideohandleChange(type.infoName,type.infoPath,$event)">
                    <a-button><a-icon type="upload" /> 上传视频 </a-button>
                  </a-upload>
                  <div style="display: flex;flex-direction: row;width:100%">
                    <video style="width:135px;margin:10px;margin-left:0px" v-for="item in type.clientVideo" :key="index" :src="item+'&token='+token" controls></video>
                  </div>
                </a-col>

                <!--销单资料-->
                <a-col :span="20">
                  <a-row>
                    <a-col :span="5" v-for="tab in type.dataInfoList" style="height: 250px;margin-left: 30px;">
                      <p style="text-align: center">{{tab.name}}</p>
                      <a href="#" onclick="return false;">
                        <a-icon type="check-circle" @click="disablesale(tab.uid,0)" v-if="tab.forbiddenStatus==1" style="width: 20px;height: 20px;position: absolute;right: 50px;top:42px;font-size:20px;color: #ccc;z-index:500" />
                        <a-icon type="stop" @click="disablesale(tab.uid,1)" v-if="tab.forbiddenStatus==0" style="width: 20px;height: 20px;position: absolute;right: 50px;top:42px;font-size:20px;color: #ccc;z-index:500" />
                        <a-icon type="delete" theme="filled" @click="deletesale('salevideoList',tab.uid,tab.url)" style="width: 20px;height: 20px;position: absolute;right: 15px;top:42px;font-size:20px;color: #ccc;z-index:500"/>
                      </a>
                      <video :src="process+'?fileName='+tab.url+'&token='+token" style="margin-bottom: 20px" width="100%" height="70%" controls></video>
                      <div>{{tab.createTime}}</div>
                      <div>{{tab.createBy }}</div>
                    </a-col>
                  </a-row>
                </a-col>
              </a-row>
              <a-divider/>
            </div>
            <a-row style="margin: 20px">
              <a-col :span="24" style="display: flex;justify-content: center;">
                <a-form-item>
                  <a-button style="background-color: #6DBCFF;color: white;" @click="saleDataSave()">
                    提交
                  </a-button>
                </a-form-item>
              </a-col>
            </a-row>
          </div>
        </a-tab-pane>
        <a-tab-pane key="4" tab="问题反馈">
          <div class="table-page-search-wrapper">
            <a-form layout="inline" :form="formfeedback">
              <a-row :gutter="24">
                <a-col :span="6">
                  <a-form-item label="订单号" style="margin-left:45px">
                    <a-input v-decorator="['orderNo']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="安装类别" style="margin-left:30px">
                    <a-input v-decorator="['installType']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="订单类型" style="margin-left:30px">
                    <a-input v-decorator="['orderType']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="数量" style="margin-left:60px">
                    <a-input v-decorator="['quantity']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="客户姓名" style="margin-left:30px">
                    <a-input v-decorator="['clientName']" disabled="disabled" />
                  </a-form-item>
                </a-col>
                <a-col :span="6">
                  <a-form-item label="客户联系方式">
                    <a-input v-decorator="['clientPhone']" disabled="disabled" />
                  </a-form-item>
                </a-col>
              </a-row>
              <a-table size="default" ref="feedbackTable" :columns="columnfeedback" :dataSource="this.feedbacklist.feedbackList"
                       :pagination="false" :scroll="{ x: 1600}" bordered style="margin-top: 30px">
                <span slot="action" slot-scope="text, record">
                  <a @click="problemsDealing(record)" v-if="record.handlingStatus!='结束'">处理</a>
                  <a-divider type="vertical" v-if="!record.handleStartTime" />
                  <a v-if="!record.handleStartTime" @click="revoke(record)">撤回</a>
                  <a-divider type="vertical" />
                  <a @click="problemsTransfer(record)">转派</a>
                </span>
              </a-table>
            </a-form>
          </div>
        </a-tab-pane>
      </a-tabs>
      <div>
        <a-affix class="scroll" style="position: fixed;right:  9%;bottom: 10px;z-index: 10;">
          <div>
            <a-button style="margin-bottom: 8px;width: 110px;height: 46px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;" @click="requirementsEnterprise">
              <img src="../../../../public/images/requirements.png" alt="" style="width:28px;height:28px">
              <span style="margin-left: 5px">企业要求</span>
            </a-button>
          </div>
          <div>
            <a-button @click="problemInitiate" style="margin-bottom: 8px;width: 110px;height: 46px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;">
              <img src="../../../../public/images/initiate.png" alt="" style="width:28px;height:28px;margin-left: -18px;">
              <span style="margin-left: 5px">发起</span>
            </a-button>
          </div>
          <!--<div>-->
            <!--<a-button style="margin-bottom: 20px;width: 110px;height: 46px;text-align: center;background-color: white;box-shadow: gainsboro 0px 0px 2px 3px;cursor: pointer;" @click="toTop(step)">-->
              <!--<img src="../../../../public/images/toTop.png" alt="" style="width:28px;height:28px">-->
              <!--<span style="margin-left: 5px">回到顶部</span>-->
            <!--</a-button>-->
          <!--</div>-->
        </a-affix>
      </div>
    </a-modal>
    <!--包裹-->
    <a-modal v-model="packageable" @ok="submitPackage" :confirmLoading="packConfirmLoading" :maskClosable="false" title="包裹">
      <a-form :form="packageForm">
        <a-row>
          <a-col>
            <a-form-item style="display:none">
              <a-input v-decorator="['transportId']" />
            </a-form-item>
            <a-form-item label="包裹名称" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input v-decorator="['transportName', { rules: [{ required: true, message: '请输入包裹名称!' }] }]"/>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
              <a-select  v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]" :allowClear="true">
                <a-select-option v-for="type in delivery_company" :key="type.dictValue">
                  {{type .dictLabel}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
              <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '请输入快递单号!' }] }]"/>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="包裹备注">
              <a-input v-decorator="['remark']"/>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="">
              <a-checkbox v-decorator="['isMainbool',{valuePropName:'checked',initialValue:true}]"> 重要</a-checkbox>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--配件-->
    <a-modal v-model="accessoryVisible" @ok="submitAccessories" :confirmLoading="accessoryLoading" title="配件" :maskClosable="false" width="800px">
      <a-form :form="accessoryForm">
        <a-row>
          <a-col :span="20">
            <a-form-item style="display:none">
              <a-input v-decorator="['transportId']" />
            </a-form-item>
            <a-form-item style="display:none">
              <a-input v-decorator="['orderAccessoryId']" />
            </a-form-item>
            <a-form-item v-if='!nameible' label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-select  @change="accessoryChange" v-decorator="['accessoryId', { rules: [{ required: true, message: '选择配件信息!' }] }]" :allowClear="true">
                <a-select-option v-for="type in EnterpriseAccessory" :key="type.accessoryId">
                  {{type.accessoryName}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if='nameible' label="配件信息" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled="disabled" v-decorator="['accessoryName',{ rules: [{ required: true, message: '填写配件信息!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件单价">
              <a-input disabled="disabled" v-decorator="['price', { rules: [{ required: true, message: '填写配件单价!' }] }]" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="数量">
              <a-input-number style="width: 100%" v-decorator="['accessoryNum',{ rules: [{ required: true, message: '填写数量!' }] ,initialValue: 1}]" @change="accessoryNumChange" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="配件总金额">
              <a-input disabled="disabled" v-decorator="['totalAmount', { rules: [{ required: true, message: '配件总金额!' }] }]" />
            </a-form-item>
            <a-form-item v-if='!nameible' :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货仓库">
              <a-select  v-decorator="['repositoryId', { rules: [{ required: true, message: '选择发货仓库!' }] }]" :allowClear="true">
                <a-select-option v-for="type in queryEnterpriseStock" :key="type.storeId">
                  {{type.storeName}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item v-if='nameible' label="发货仓库" :labelCol="labelCol" :wrapperCol="wrapperCol">
              <a-input disabled="disabled" v-decorator="['repositoryName',{ rules: [{ required: true, message: '填写发货仓库!' }] }]" />
            </a-form-item>
          </a-col>
        </a-row>
        <a-divider orientation="left"></a-divider>
        <a-checkbox :labelCol="labelCol" :wrapperCol="wrapperCol" :checked="deliveryShow" @change="onChangeinfo">物流信息</a-checkbox>
        <a-row v-if="deliveryShow">
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
              <a-date-picker v-model="deliveryTime" style="width: 100%;" @change="onChangeT" format="YYYY-MM-DD" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
              <a-select v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]" :allowClear="true">
                <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{type .dictLabel}}</a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
              <a-input v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
            </a-form-item>
          </a-col>
          <a-col :span="12">
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货人">
              <a-input v-decorator="['sendUser']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="收货人">
              <a-input v-decorator="['receiveUser']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="备注">
              <a-input v-decorator="['transportRemark']" />
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--配件退回-->
    <a-modal title="配件退回" style="top: 20px;" v-model="accessoriesReturnidle" :confirmLoading="accessoryReturnLoading" :maskClosable="false" @ok="addaccessoriesReturn">
      <a-form :form="formaccessoriesReturn">
        <a-form-item style="display:none">
          <a-input v-decorator="['orderAccessoryId']" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="发货日期">
          <a-date-picker v-model="deliveryTimeReturn" style="width: 100%;" @change="onChangeaccessories" format="YYYY-MM-DD" />
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递公司">
          <a-select  v-decorator="['transportCode', { rules: [{ required: true, message: '选择快递公司!' }] }]" :allowClear="true">
            <a-select-option v-for="type in delivery_company" :key="type.dictValue">{{type .dictLabel}}</a-select-option>
          </a-select>
        </a-form-item>
        <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="快递单号">
          <a-input  v-decorator="['transportNo', { rules: [{ required: true, message: '选择快递单号!' }] }]" />
        </a-form-item>
      </a-form>
    </a-modal>
    <!--查看物流信息-->
    <a-modal v-model="transportble" :footer="null" title='快递物流信息'>
      <a-form :form="form" v-if="transportInfo">
        <a-steps progress-dot :current="transportInfo.length" direction="vertical" style="width: 100%">
          <a-step v-for="(type,index) in transportInfo" :key="index" :title="type.ftime" :description="type.context" style="width: 100%" />
        </a-steps>
      </a-form>
    </a-modal>
    <!--查看企业要求-->
    <a-modal v-model="showMasterAmount" :footer="null" title="企业要求" :maskClosable="false">
      <!--<h3>要求内容:</h3>-->
      <div style="margin:0 10px">
        <div v-if="masterDemandList.length > 0">
          <div v-for="(item,index) in masterDemandList" style="padding: 3px;color:#000;display: flex;align-items: baseline">
            <span style="margin-right: 5px">{{index + 1}}. </span><p style="padding: 5px;border:1px solid #ccc;">{{item}}</p>
          </div>
        </div>
        <div v-else style="text-align: center">
          <span style="color: #aaa">暂无数据</span>
        </div>
      </div>

    </a-modal>
    <!--发起-->
    <a-modal v-model="problemible" @ok="addproblem()" title="问题反馈" :width="600" :maskClosable="false">
      <a-form :form="problemform">
        <a-row>
          <a-col>
            <a-form-item style="display:none">
              <a-input v-decorator="['orderId']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="当前订单号">
              <a-input v-decorator="['orderNo']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="处理人">
              <a-input v-decorator="['handler']" disabled="disabled" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题类型">
              <a-select v-decorator="['matterCode', { rules: [{
              required: true, message: '请选择问题类型!' }] }]"
                        :allowClear="true" @change="onChangefeedback">
                <a-select-option v-for="type in feedbackAuthority" :key="type.code">{{type.name}}
                </a-select-option>
              </a-select>
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="问题内容">
              <a-textarea v-decorator="['contents']" />
            </a-form-item>
            <a-form-item :labelCol="labelCol" :wrapperCol="wrapperCol" label="上传图片">
              <a-upload name="file" :multiple="true" :action="currencyuploadUrl" list-type="picture-card" class="avatar-uploader"
                        :file-list="problemfileList" :headers="headers" @preview="handlePreview" @change="complainthandleChange">
                <a-icon type="upload" />
                <div class="ant-upload-text">
                  图片
                </div>
                <a-modal :visible="previewVisible" :footer="null" @cancel="handleCancel">
                  <img alt="example" style="width: 100%" :src="previewImage" />
                </a-modal>
              </a-upload>
            </a-form-item>
          </a-col>
        </a-row>
      </a-form>
    </a-modal>
    <!--销单资料 查看图片 弹框-->
    <a-modal :visible="previewimgible" :footer="null" @cancel="previewimghandleCancel">
      <img alt="example" style="width: 100%;padding: 10px" :src="previewimgurl" />
    </a-modal>
    <feedbackorder-model ref="feedbackorder" @ok="feedbackTable()"></feedbackorder-model>
  </div>
</template>

<script>
  import { checkPermission } from '@/utils/permissions'
  import { STable } from '@/components'
  import { ACCESS_TOKEN } from '@/store/mutation-types'
  import store from '@/store'
  import pick from 'lodash.pick'
  import moment from 'moment';
  import feedbackorderModel from './feedbackorderModel'
  import { getOrderDetails,getselectCityName,getselectAreaName,getfinddictAll,getaddTransport,getdelTransport,queryMasterAccessory,addOrderAccessory,getreturnOrderAccessory,getinvalidOrderAccessory,getTransportInfo,masterPrice,masterDemand,getaddFeedback,getFeedbackAuthority,getprocessor,getfeedbacklist,getsaleOrderData,getsaleDataSave,getdisablesale,getdeletesale } from '@/api/order/MasterOrderList'
  import { getqueryEnterpriseAccessoryPrice,getqueryEnterpriseStock } from '@/api/order/NewlyaddedOrderList'
  import ATextarea from "ant-design-vue/es/input/TextArea";

  export default {
    name: "editMasterOrderList",
    components: {
      ATextarea,
      feedbackorderModel
    },
    data () {
      return {
        labelCol: {
          xs: { span: 24 },
          sm: { span: 5 }
        },
        wrapperCol: {
          xs: { span: 24 },
          sm: { span: 16 }
        },
        store,
        dateFormat: 'YYYY-MM-DD',
        form: this.$form.createForm(this),
        packageForm: this.$form.createForm(this),  // 包裹
        accessoryForm: this.$form.createForm(this),  // 配件
        formaccessoriesReturn: this.$form.createForm(this),  // 配件退回
        formmoney: this.$form.createForm(this),  // 金额信息
        problemform: this.$form.createForm(this),  // 发起
        formfeedback: this.$form.createForm(this),  // 问题反馈
        mdl:{},
        // 上传图片
        previewVisible: false,
        previewImage: '',
        headers: {
          token: Vue.ls.get(ACCESS_TOKEN)
        },
        process: process.env.VUE_APP_API_BASE_URL + '/dfs/download',  // 销单资料 图片回显
        uploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/uploadSaleOrderData',  // 销单资料 上传地址
        currencyuploadUrl: process.env.VUE_APP_API_BASE_URL + '/dfs/upload?type=order',// 问题反馈 上传图片
        problemfileList: [], // 发起  上传图片
        complaintfilelist: [], // 发起  上传图片（提交）
        expectInstallTime: '', // 期望安装时间 回显
        expectInstallTime1: '', // 期望安装时间 提交
        deliveryTime: '', // 发货日期 回显
        deliveryTime1: '', // 发货日期 提交
        deliveryTimeReturn: '', // 退回时间
        editMasterOrder: false, // 编辑页显示、隐藏
        editConfirmLoading:false, // 编辑页 确定loading
        packageable: false, // 包裹弹框显示、隐藏
        packConfirmLoading: false, // 包裹页 确定loading
        packLoading: false, // 包裹的table数据 loading状态
        accessoryVisible: false, // 配件 弹框显示、隐藏
        accessoryLoading: false, // 配件页 确定loading
        accessoryTableLoading:false, // 配件的table数据 loading状态
        nameible: false, // 配件弹框中 切换 输入框、下拉框
        deliveryShow: false, // 物流信息
        accessoriesReturnidle: false, // 配件退回 弹框显示、隐藏
        accessoryReturnLoading: false, // 配件退回 确定loading
        transportble: false, // 查看物流信息 弹框
        showMasterAmount: false, // 企业要求
        problemible:false,  // 发起 弹框
        // 期望安装时间下拉
        timeselect: [
          {
            value: '07-09',
            label: '7-9点'
          }, {
            value: '09-11',
            label: '9-11点'
          }, {
            value: '11-13',
            label: '11-13点'
          }, {
            value: '13-15',
            label: '13-15点'
          }, {
            value: '15-17',
            label: '15-17点'
          }, {
            value: '17-19',
            label: '17-19点'
          }, {
            value: '19-21',
            label: '19-21点'
          }, {
            value: '21-07',
            label: '21-次日7点'
          }
        ],
        // 包裹
        columnspackage: [
          {
            title: '序号',
            align: 'center',
            customRender: (text, record, index) => `${index + 1}`,
            width: 80,
          }, {
            title: '操作',
            width: 120,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' }
          }, {
            title: '包裹',
            dataIndex: 'name',
            align: 'center'
          }, {
            title: '快递公司',
            dataIndex: 'transportName',
            align: 'center'
          }, {
            title: '快递单号',
            dataIndex: 'transportNo',
            align: 'center'
          }, {
            title: '快递状态',
            dataIndex: 'transportStatusName',
            align: 'center'
          }, {
            title: '包裹备注',
            dataIndex: 'remark'
          }, {
            title: '重要',
            dataIndex: 'isMain',
            customRender: (text) => {
              if (text == '1') {
                return '重要'
              } else {
                return ''
              }
            },
            align: 'center'
          }
        ],
        // 配件
        columnsAddaccessories: [
          {
            title: '序号',
            align: 'center',
            customRender: (text, record, index) => `${index + 1}`,
          }, {
            title: '操作',
            dataIndex: 'action',
            scopedSlots: {
              customRender: 'action'
            }
          }, {
            title: '配件名称',
            align: 'center',
            dataIndex: 'accessoryName'
          }, {
            title: '数量',
            align: 'center',
            dataIndex: 'accessoryNum'
          }, {
            title: '配件单价',
            align: 'center',
            dataIndex: 'price'
          }, {
            title: '配件总金额',
            align: 'center',
            dataIndex: 'totalAmount'
          }, {
            title: '发货日期',
            align: 'center',
            dataIndex: 'deliveryTime'
          }, {
            title: '快递公司',
            align: 'center',
            dataIndex: 'transportName'
          }, {
            title: '快递单号',
            align: 'center',
            dataIndex: 'transportNo',
            scopedSlots: {
              customRender: 'transport'
            }
          }, {
            title: '快递状态',
            align: 'center',
            dataIndex: 'transportStatus'
          }, {
            title: '发货仓库',
            align: 'center',
            dataIndex: 'storeName'
          }, {
            title: '发货人',
            align: 'center',
            dataIndex: 'sendUser'
          }, {
            title: '收货人',
            align: 'center',
            dataIndex: 'receiveUser'
          }
        ],
        // 金额信息
        columnsenterprise: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            align: 'center'
          }, {
            title: '金额类型',
            dataIndex: 'priceTypeName',
            align: 'center'
          }, {
            title: '数量',
            dataIndex: 'num',
            align: 'center'
          }, {
            title: '初始单价',
            dataIndex: 'originalPrice',
            align: 'center'
          }, {
            title: '初始金额',
            dataIndex: 'originalTotal',
            align: 'center'
          }, {
            title: '修改金额',
            dataIndex: 'modifiedPrice',
            align: 'center'
          }, {
            title: '现订单金额',
            dataIndex: 'newTotal',
            align: 'center'
          }, {
            title: '提交人',
            dataIndex: 'submitter',
            align: 'center'
          }, {
            title: '提交时间',
            dataIndex: 'submitTime',
            align: 'center'
          }, {
            title: '金额备注',
            dataIndex: 'priceRemark',
            align: 'center'
          },
        ],
        // 问题反馈
        columnfeedback: [
          {
            title: '序号',
            customRender: (text, record, index) => `${index + 1}`,
            align: 'center'
          }, {
            title: '操作栏',
            dataIndex: 'action',
            scopedSlots: {
              customRender: 'action'
            },
          }, {
            title: '处理情况',
            dataIndex: 'handlingStatus',
            align: 'center'
          }, {
            title: '问题类型',
            dataIndex: 'matterName',
            align: 'center'
          }, {
            title: '安装类别',
            dataIndex: 'installType',
            align: 'center'
          }, {
            title: '申请人',
            dataIndex: 'initiatorName',
            align: 'center'
          }, {
            title: '申请人联系方式',
            dataIndex: 'initiatorPhone',
            align: 'center'
          }, {
            title: '问题内容',
            dataIndex: 'contents',
            align: 'center'
          }, {
            title: '申请时间',
            dataIndex: 'createTime',
            align: 'center'
          }, {
            title: '当前处理人',
            dataIndex: 'currentHandlerName',
            align: 'center'
          }, {
            title: '开始处理时间',
            dataIndex: 'handleStartTime',
            align: 'center'
          }, {
            title: '处理完成时间',
            dataIndex: 'handleEndTime',
            align: 'center'
          }, {
            title: '处理时长',
            dataIndex: 'processingTimeStr',
            align: 'center'
          }, {
            title: '处理总时长',
            dataIndex: 'totalProcessingTimeStr',
            align: 'center'
          },
        ],
        selectAllProvince: [], // 省
        selectCityName: [], // 市
        selectAreaName: [], // 区
        tabs_key: '1', // tab页
        record: '', // 本条订单的信息
        recordValue:'', // 本条订单的 详情信息
        transportList: [], // 包裹
        delivery_company: [], // 快递公司
        accessoryList: [], // 配件
        EnterpriseAccessory:[], // 配件信息下拉
        queryEnterpriseStock: [], // 发货仓库
        transportInfo: [], // 查看物流信息 数据
        amountList: [], //金额信息 数据
        masterDemandList: [], // 企业要求 内容
        feedbackAuthority: [], // 发起 问题类型
        feedbacklist: [], // 问题反馈table
        salepicList: [], // 销单资料 图片
        salevideoList: [], // 销单资料 视频
        uploadVideo: [],  // 上传视频
        previewimgible: false, // 销单资料 查看图片 弹框
        previewimgurl: '', // 销单资料 查看图片路径
        single: false, // 是否可编辑销单
      }
    },
    methods:{
      moment,
      // 编辑
      handleEdit(record,AllProvince){
        // console.log(record)
        this.recordValue = record
        this.record = record
        this.selectAllProvince = AllProvince // 省
        this.callback('1',record)
        // 快递下拉数据
        getfinddictAll({
          dictTypes: 'delivery_company'
        }).then(res => {
          this.delivery_company = res.delivery_company
        })
        if(record.orderStatusName == '待安装'){
          this.single = true
        }else{
          this.single = false
        }
      },
      // 切换tab页
      callback(key,record) {
        // console.log(key);
        this.tabs_key = key //显示当前tab页
        if(key == '1'){
          getOrderDetails({orderId:this.record.orderId}).then(res=>{
            if(res.data.accessoryList.length > 0){
              for (let item of res.data.accessoryList){
                item.price = (item.totalAmount - 0) / (item.accessoryNum - 0)
              }
            }
            this.mdl = Object.assign(res.data)
            this.transportList = this.mdl.transportList // 包裹
            this.accessoryList = this.mdl.accessoryList // 配件
            // 市
            getselectCityName({provinceCode:this.mdl.provinceCode}).then(res=>{
              this.selectCityName = res.rows
            })
            // 区
            getselectAreaName({cityCode:this.mdl.cityCode}).then(res=>{
              this.selectAreaName = res.rows
            })
            // 期望安装时间
            if(this.mdl.expectInstallTime){
              this.expectInstallTime1 = res.data.expectInstallTime
              this.expectInstallTime = moment(res.data.expectInstallTime)
            }else{
              this.expectInstallTime = null
              this.expectInstallTime1 = null
            }
            // console.log(this.mdl)
            this.editMasterOrder = true //编辑页显示
            this.$nextTick(()=>{
              // console.log(res.data)
              this.form.setFieldsValue(pick(this.mdl,'clientName','clientPhone','expectInstallTimePart','provinceCode','cityCode' ,'countyCode' ,'detailAddress' ,'clientRequire' ,'orderNo' ,'serialNumber'))
            })
          }).catch(() => {
            this.$message.error('系统错误，请稍后再试')
          })
        }else if(key == '2'){
          this.amountInformation()
        }else if(key == '3'){
          this.handleSaleOrder()
        }else if(key == '4'){
          this.feedbackTable()
        }
      },
      // 上传图片 之前
      beforeUpload(file) {
        //console.log(file)
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        if (!isJpgOrPng) {
          this.$message.error('上传文件格式不支持!');
          return false
        }
      },
      // 上传图片
      salepichandleChange(infoName, infoPath, info, index) {
        this.salepicList[index].salepicfileList = info.fileList
        this.salepicList = _.cloneDeep(this.salepicList)
        console.log(this.salepicList)
        if (info.file.status === 'removed') {
          if (info.file.response.code == 0) {
            this.salepicList.forEach(tab => {
              if (tab.infoName == infoName) {
                const index = tab.infoPath.indexOf(info.file.response.url);
                tab.infoPath.splice(index, 1);
              }
            })
          }
        }
        if (info.file.status === 'done') {
          if (info.file.response.code == 0) {
            this.salepicList.forEach(tab => {
              if (tab.infoName == infoName) {
                if (tab.infoPath) {
                  tab.infoPath.push(info.file.response.url)
                  console.log(tab.infoPath)
                } else {
                  tab.infoPath = []
                  tab.infoPath.push(info.file.response.url)
                }
              }
            })
          }
          console.log(this.salepicList)
          this.$message.success(`${info.file.name}上传成功`);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      // 上传视频
      salevideohandleChange(infoName, infoPath, info) {
        if (info.file.status === 'removed') {
          if (info.file.response.code == 0) {
            this.salevideoList.forEach(tab => {
              if (tab.infoName == infoName) {
                const index = tab.infoPath.indexOf(info.file.response.url);
                tab.infoPath.splice(index, 1);
              }
            })
          }
        }
        if (info.file.status === 'done') {
          if (info.file.response.code == 0) {
            this.salevideoList.forEach(tab => {
              if (tab.infoName == infoName) {
                if (tab.infoPath) {
                  tab.infoPath.push(info.file.response.url)
                } else {
                  tab.infoPath = []
                  tab.infoPath.push(info.file.response.url)
                }
              }
            })
          }
          info.file.response.url = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + info.file.response.url
          this.salevideoList.forEach(tab => {
            if (tab.infoName == infoName) {
              this.uploadVideo.push(info.file.response.url)
              tab.clientVideo = this.uploadVideo
            } else {
              this.uploadVideo = []
            }
          })
          this.salevideoList = _.cloneDeep(this.salevideoList)
          this.$message.success(`${info.file.name}上传成功`);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      // 提交 销单资料
      saleDataSave() {
        let saleDataSaveobj = {}
        saleDataSaveobj.picList = this.salepicList
        saleDataSaveobj.videoList = this.salevideoList
        saleDataSaveobj.orderId = this.recordValue.orderId
        console.log('heixiao', saleDataSaveobj)
        getsaleDataSave(saleDataSaveobj).then(res => {
          if (res.code === 0) {
            this.$message.success('提交成功');
            this.handleSaleOrder()
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 查看图片
      previewimg(url) {
        this.previewimgurl = this.process + '?fileName=' + url + '&token=' + this.token
        this.previewimgible = true
      },
      previewimghandleCancel() {
        this.previewimgible = false
      },
      // 禁用图片、视频
      disablesale(id, Status) {
        getdisablesale({
          typeId: id,
          forbiddenStatus: Status
        }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功');
            this.handleSaleOrder()
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 删除图片、视频
      deletesale(type, id, url) {
        if (type == 'salevideoList') {
          this.salevideoList.forEach(item => {
            if (item.infoPath) {
              if (item.infoPath.length > 0) {
                item.infoPath.forEach(tab => {
                  if (tab == url) {
                    item.infoPath.splice(url, 1)
                  }
                })
              }
            }
          })
        }
        if (type == 'salepicList') {
          this.salepicList.forEach(item => {
            if (item.infoPath) {
              if (item.infoPath.length > 0) {
                item.infoPath.forEach(tab => {
                  if (tab == url) {
                    item.infoPath.splice(url, 1)
                  }
                })
              }
            }
          })
        }
        getdeletesale({ cosmtId: id }).then(res => {
          if (res.code === 0) {
            this.$message.success('操作成功');
            this.handleSaleOrder()
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 刷新 销单资料
      handleSaleOrder(){
        getsaleOrderData({
          orderId: this.recordValue.orderId
        }).then(res => {
          if (res.code === 0) {
            this.$nextTick(()=>{
              this.salepicList = res.data.picList
              // 回显
              this.salepicList.forEach(item => {
                item.salepicfileList = []
              })
              this.salevideoList = res.data.videoList
            })
          } else {
            this.$message.error(res.msg);
          }
        })
      },


      // 新增包裹
      packageAdd(){
        this.packageable = true // 包裹弹框显示
        this.packageForm.resetFields()
      },
      // 编辑包裹
      packageEdit(record){
        this.packageForm.resetFields()
        this.packageable = true  // 包裹弹框显示
        record.isMainbool = record.isMain == 0 ? false : true,
        this.$nextTick(() => {
          this.packageForm.setFieldsValue({transportName: record.name})
          this.packageForm.setFieldsValue(pick(record, 'transportId', 'transportCode', 'transportNo', 'remark', 'isMainbool'))
        })
      },
      // 提交新增包裹
      submitPackage(){
        this.packageForm.validateFields((err, values) => {
          values.orderId = this.recordValue.orderId
          values.isMain = values.isMainbool ? '1' : '0' //是否 重要包裹
          if (!err) {
            this.packConfirmLoading = true  // 打开包裹页确定loading
            getaddTransport(values).then(res => {
              if (res.code == 0) {
                this.$message.success('新增成功')
                this.packageable = false  // 包裹弹框 隐藏
                this.packConfirmLoading = false  // 关闭包裹页确定loading
                this.packLoading = true  // 包裹的table 刷新
              } else {
                this.$message.error(res.msg);
              }
            }).then(res=>{
              this.refreshPack()
            }).catch(() => {
              this.$message.error('系统错误，请稍后再试')
            })
          }
        })
      },
      // 删除包裹
      removepackage(id){
        getdelTransport({
          transportId: id
        }).then(res => {
          if (res.code == 0) {
            this.packLoading = true  // 包裹的table 刷新
            this.$message.success('删除成功')
          }else {
            this.$message.error(res.msg);
          }
        }).then(res =>{
          this.refreshPack()
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },
      // 刷新包裹talbe数据
      refreshPack(){
        getOrderDetails({orderId:this.recordValue.orderId}).then(res => {
          if (res.code == 0) {
            this.transportList = res.data.transportList
            this.packLoading = false  // 包裹的table 取消刷新
          } else {
            this.$message.error(res.msg);
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },


      // 新增配件
      accessoryAdd(){
        this.accessoryForm.resetFields()
        this.deliveryTime = null  // 发货时间 回显
        this.deliveryTime1 = null  // 发货时间 提交
        queryMasterAccessory({orderId:this.recordValue.orderId}).then(res=>{
          this.EnterpriseAccessory = res.rows
        })
        this.deliveryShow = false  //物流信息
        this.nameible = false  // 显示下拉框
        this.accessoryVisible = true  // 配件弹框
      },
      // 编辑配件
      accessoryEdit(record) {
        console.log('配件',record)
        //获取企业配件金额
        this.accessoryForm.resetFields()
        this.deliveryTime = null  // 发货时间 回显
        this.deliveryTime1 = null  // 发货时间 提交
        if (record.deliveryTime) {
          this.deliveryTime1 = record.deliveryTime
          this.deliveryTime = moment(record.deliveryTime, this.dateFormat)
        }
        this.accessoryVisible = true
        if (record.transportNo) {
          this.deliveryShow = true
        } else {
          this.deliveryShow = false
        }
        this.nameible = true
        this.queryEnterpriseStock = [];
        let totalAmount = record.totalAmount
        let accessoryNum = record.accessoryNum
        setTimeout(() => {
          this.accessoryForm.setFieldsValue({
            price: (totalAmount - 0) / (accessoryNum - 0),
            transportCode: record.transportCode,
            totalAmount: totalAmount,
            repositoryName: record.storeName
          })
        }, 100)
        this.$nextTick(() => {
          this.accessoryForm.setFieldsValue(pick(record, 'orderAccessoryId', 'accessoryId', 'transportId', 'accessoryName', 'accessoryNum', 'totalAmount', 'repositoryId', 'transportNo', 'sendUser', 'receiveUser', 'transportRemark', )
          )
        })
      },
      // 修改配件信息
      accessoryChange(e) {
        // console.log(e)
        let accessoryNum = this.accessoryForm.getFieldValue('accessoryNum')
        for(let item of this.EnterpriseAccessory){
          if(item.accessoryId == e){
            let list = {
              storeId:item.storeId,
              storeName:item.storeName
            }
            this.queryEnterpriseStock.push(list)
            this.$nextTick(()=>{
              this.accessoryForm.setFieldsValue({
                price: item.amount,
              })
              this.accessoryNumChange(accessoryNum)
            })
            return
          }
        }
      },
      // 修改配件数量
      accessoryNumChange(value) {
        let amount = this.accessoryForm.getFieldValue('price')
        this.accessoryForm.setFieldsValue({
          totalAmount: (amount - 0) * (value - 0),
        })
      },
      // 提交新增配件
      submitAccessories(){
        this.accessoryForm.validateFields((err, values) => {
          values.orderId = this.recordValue.orderId
          values.deliveryTime = this.deliveryTime1
          if (!err) {
            this.accessoryLoading = true // 配件页确定loading
            addOrderAccessory(values).then(res => {
              if(res.code == 0){
                this.$message.success('新增成功')
                this.accessoryVisible = false // 配件弹框显示、隐藏
                this.accessoryLoading = false // 配件页确定loading
                this.accessoryTableLoading = true
              }
            }).then(res=>{
              this.refreshAccessory()
            })
          } else {
            this.$message.error('未填写数据')
          }
        });
      },
      // 刷新配件talbe数据
      refreshAccessory(){
        getOrderDetails({orderId:this.recordValue.orderId}).then(res => {
          if (res.code == 0) {
            this.accessoryList = res.data.accessoryList // 配件
            this.accessoryTableLoading = false  // 配件的table 取消刷新
          } else {
            this.$message.error(res.msg);
          }
        }).catch(() => {
          this.$message.error('系统错误，请稍后再试')
        })
      },
      // 发货时间
      onChangeT(date, dateString) {
        this.deliveryTime1 = dateString
      },
      // 物流信息展示、隐藏
      onChangeinfo(e){
        this.deliveryShow = !this.deliveryShow
      },


      // 退回
      partsReturn(record) {
        this.accessoriesReturnidle = true // 配件退回 弹框显示、隐藏
        this.formaccessoriesReturn.resetFields()
        this.deliveryTimeReturn = null
        this.$nextTick(() => {
          this.formaccessoriesReturn.setFieldsValue(pick(record, 'orderAccessoryId'))
        })
      },
      // 提交回退
      addaccessoriesReturn() {
        this.formaccessoriesReturn.validateFields((err, values) => {
          values.deliveryTime = this.deliveryTimeReturn
          // console.log(values)
          if (!err) {
            this.accessoryReturnLoading = true // 配件退回 确定loading
            getreturnOrderAccessory(values).then(res => {
              if (res.code === 0) {
                this.$message.success('退回成功');
                this.accessoriesReturnidle = false // 配件退回 弹框显示、隐藏
                this.accessoryTableLoading = false // 配件的table 取消刷新
                this.accessoryReturnLoading = false // 配件退回 确定loading
              } else {
                this.$message.error(res.msg);
              }
            }).then(res=>{
              this.refreshAccessory()
            })
          }
        });
      },
      // 作废
      partsObsolete(id) {
        getinvalidOrderAccessory({ orderAccessoryId: id }).then(res => {
          if (res.code === 0) {
            this.$message.success('作废成功');
            this.accessoryTableLoading = true // 配件的table 取消刷新
          }
        }).then(res=>{
          this.refreshAccessory()
        })
      },
      // 退回发货时间
      onChangeaccessories(date, dateString) {
        this.deliveryTimeReturn = dateString
      },
      // 点击快递单号，查看物流
      gettransport(Code, No) {
        // console.log(Code)
        getTransportInfo({ transportCode: Code, transportNo: No }).then(res => {
          if (res.code === 0) {
            this.transportble = true
            this.transportInfo = res.data;
          } else {
            this.$message.error(res.msg);
          }
        })
      },


      // 金额信息
      amountInformation(){
        masterPrice({orderId:this.recordValue.orderId}).then(res=>{
          // console.log('tab2',res.data)
          this.amountList = res.data.masterPrice
          this.$nextTick(() => {
            this.formmoney.setFieldsValue(pick(res.data, 'orderNo', 'installTypeName', 'orderTypeName', 'num', 'enterpriseName', 'masterSettlementAount', 'masterTotalAmount' ))
          })
        })
      },
      // 企业要求
      requirementsEnterprise(){
        masterDemand({orderId:this.record.orderId}).then(res=>{
          // console.log(res.rows)
          this.masterDemandList = res.rows
          this.showMasterAmount = true
        })
      },
      // 发起
      problemInitiate() {
        this.problemform.resetFields()
        this.problemible = true
        this.problemfileList = []
        this.complaintfilelist = []
        getFeedbackAuthority().then(res => {
          if (res.code === 0) {
            // console.log(res)
            this.feedbackAuthority = res.data
          } else {
            this.$message.error(res.msg);
          }
        })
        this.$nextTick(() => {
          this.problemform.setFieldsValue(pick(this.recordValue, 'orderNo', 'orderId'))
        })
      },
      // 问题类型
      onChangefeedback(e) {
        let obj = {}
        obj.relationType = 'orderId'
        obj.relationId = this.recordValue.orderId
        obj.matterCode = e
        getprocessor(obj).then(res => {
          // console.log(res)
          if (res.code === 0) {
            this.problemform.setFieldsValue({
              handler: res.rows,
            })
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 上传图片
      complainthandleChange(info) {
        this.problemfileList = info.fileList
        if (info.file.status === 'removed') {
          if (info.file.response.code == 0) {
            const index = this.complaintfilelist.indexOf(info.file.response.url);
            this.complaintfilelist.splice(index, 1);
          }
        }
        if (info.file.status === 'done') {
          if (info.file.response.code == 0) {
            let list = {}
            list.url = info.file.response.url
            list.uid = info.fileList[0].uid
            list.name = info.fileList[0].name
            list = JSON.stringify(list)
            this.complaintfilelist.push(list)
          }
          this.$message.success(`${info.file.name}上传成功`);
        } else if (info.file.status === 'error') {
          this.$message.error(`${info.file.name} 上传失败.`);
        }
      },
      async handlePreview(file) {
        console.log(file.url,file.preview,file.originFileObj)
        if(file.response){
          this.previewImage = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.response.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
        }else{
          this.previewImage = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(ACCESS_TOKEN)
        }
        // if (!file.url && !file.preview) {
        //   file.preview = await getBase64(file.originFileObj);
        // } else {
        //   file.url = process.env.VUE_APP_API_BASE_URL + '/dfs/download?fileName=' + file.url + '&token=' + Vue.ls.get(
        //     ACCESS_TOKEN)
        // }
        // this.previewImage = file.url || file.preview;
        //console.log(this.previewImage)
        this.previewVisible = true;
      },
      handleCancel() {
        this.previewVisible = false;
      },
      //  提交发起
      addproblem() {
        this.problemform.validateFields((err, values) => {
          values.picUrlList = this.complaintfilelist
          if (!err) {
            values.initiator = this.$store.getters.userId
            getaddFeedback(values).then(res => {
              if (res.code === 0) {
                this.$message.success('新增问题反馈成功');
                getfeedbacklist({
                  orderId: this.recordValue.orderId
                }).then(res => {
                  if (res.code === 0) {
                    this.feedbacklist.feedbackList = res.data.feedbackList
                  } else {
                    this.$message.error(res.msg);
                  }
                })
                this.problemible = false
              } else {
                this.$message.error(res.msg);
              }
            })
          }
        })
      },

      // 问题反馈初始、刷新数据
      feedbackTable(){
        getfeedbacklist({
          orderId: this.recordValue.orderId
        }).then(res => {
          if (res.code === 0) {
            this.feedbacklist = res.data
            this.formfeedback.resetFields()
            this.$nextTick(() => {
              // console.log(this.feedbacklist)
              this.formfeedback.setFieldsValue(pick(res.data, 'orderNo', 'installType', 'orderType',
                'quantity', 'clientName', 'clientPhone'))
            })
          } else {
            this.$message.error(res.msg);
          }
        })
      },
      // 撤回
      revoke(record) {
        this.$refs.feedbackorder.revoke(record)
      },
      // 处理
      problemsDealing(record) {
        this.$refs.feedbackorder.problemsDealing(record)
      },
      // 转派
      problemsTransfer(record) {
        this.$refs.feedbackorder.problemsTransfer(record)
      },

      // 复制
      Copys(){
        let provinceCode = ''
        this.selectAllProvince.forEach(item => {
          if (this.form.getFieldValue('provinceCode') == item.provinceCode) {
            provinceCode = item.provinceName
          }
        })
        let cityCode = ''
        this.selectCityName.forEach(item => {
          if (this.form.getFieldValue('cityCode') == item.cityCode) {
            cityCode = item.cityName
          }
        })
        let areaCode = ''
        this.selectAreaName.forEach(item => {
          if (this.form.getFieldValue('areaCode') == item.areaCode) {
            areaCode = item.areaName
          }
        })
        this.copyData = `客户姓名:` + this.form.getFieldValue('clientName') + '\n' + `客户联系方式:` + this.form.getFieldValue('clientPhone') + '\n' + `客户地址:` + provinceCode + cityCode + countyCode + this.form.getFieldValue('detailAddress')
        //console.log(this.copyData)
        this.handcopy(this.copyData)
      },
      handcopy(data) {
        let url = data;
        let oInput = document.createElement('textArea');
        oInput.value = url;
        document.body.appendChild(oInput);
        oInput.select(); // 选择对象;
        console.log(oInput.value)
        document.execCommand("Copy"); // 执行浏览器复制命令
        this.$message.success('复制成功')
        oInput.remove()
      },

      // 固定下拉框
      getPopupContainer(trigger) {
        return trigger.parentElement
      },

      // 省
      // getProvince(e){
      //   this.selectCityName=[]
      //   this.selectAreaName=[]
      //   this.form.setFieldsValue({'customerCityCode':undefined,'customerAreaCode':undefined,'customerDetailAddress':undefined})
      //   getselectCityName({provinceCode:e}).then(res=>{
      //     this.selectCityName=res.rows
      //   })
      // },
      // 市
      // getCityName(e){
      //   this.selectAreaName=[]
      //   this.form.setFieldsValue({'customerAreaCode':undefined,'customerDetailAddress':undefined})
      //   getselectAreaName({cityCode:e}).then(res=>{
      //     this.selectAreaName=res.rows
      //   })
      // },
      // 区
      // getAreaName(e){
      //   this.form.setFieldsValue({'customerDetailAddress':''})
      // },
      // 固定下拉框位置
    },
  }
</script>

<style scoped>
 /deep/ .ant-steps-dot .ant-steps-item-content {
    width: 438px;
 }
 .disEvents {
   pointer-events: none;
 }
</style>